const MyHoursOverviewPageActionTypes = {
  SELECT_TAB: 'MY_HOURS_OVERVIEW_PAGE_SELECT_TAB'
};

export default MyHoursOverviewPageActionTypes;
